import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"


export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatErrorMessage(error) {
  if (!error) return "An unexpected error occurred";

  // Check for backend specific error structure
  if (error.response?.data?.detail) {
    const detail = error.response.data.detail;

    // If detail is a string, return it
    if (typeof detail === "string") {
      return detail;
    }

    // If detail is an array (common in Pydantic validation errors)
    if (Array.isArray(detail)) {
      // Try to construct a readable message from the first error
      if (detail.length > 0 && detail[0].msg) {
        return detail.map(err => `${err.loc?.[1] || 'field'}: ${err.msg}`).join(", ");
      }
      return JSON.stringify(detail);
    }

    // If detail is an object, stringify it
    if (typeof detail === "object") {
      return JSON.stringify(detail);
    }
  }

  // Fallback to standard error message property
  if (error.message) {
    if (error.message === "Network Error") return "Network Error";
    return error.message;
  }

  return "An unexpected error occurred";
}
